export const CORP_CLIENT_LIST = "CORP_CLIENT_LIST";
export const POC_LIST = "POC_LIST";
export const MEETING_SITES = "MEETING_SITES";
export const CORP_CLIENT_EMAIL = "CORP_CLIENT_EMAIL"; 
export const MOM_LISTING = "MOM_LISTING";
export const BA_OPPORTUNITY_FROM_LEADX = "BA_OPPORTUNITY";